
import { Card } from 'antd';
import BreadcrumbList from '../../Stock/components/Breadcrumb';
import CancelOrder from '../../Return/pages/CancelOrder';


const CreateShippingReturn = () => {

  const listBreadcrumb = [
    {
      tittle: '배송 관리',
      url: ''
    },
    {
      tittle: '반품 요청',
      url: ''
    },
  ];

  return (
    <>
      <BreadcrumbList listBreadcrumb={listBreadcrumb} />
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card btnImport"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <div className="choosenCancel">
            <CancelOrder tab='1'/>
            </div>
        </Card>
      </div>
    </>
  );
};
export default CreateShippingReturn;
